var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3H1.875C1.75068 3 1.63145 3.05268 1.54354 3.14645C1.45564 3.24021 1.40625 3.36739 1.40625 3.5V12C1.40625 12.2652 1.50502 12.5196 1.68084 12.7071C1.85665 12.8946 2.09511 13 2.34375 13H12.6562C12.9049 13 13.1433 12.8946 13.3192 12.7071C13.495 12.5196 13.5938 12.2652 13.5938 12V3.5C13.5938 3.36739 13.5444 3.24021 13.4565 3.14645C13.3685 3.05268 13.2493 3 13.125 3ZM11.9197 4L7.5 8.32187L3.08027 4H11.9197ZM12.6562 12H2.34375V4.63688L7.18301 9.36875C7.26949 9.45343 7.38261 9.50041 7.5 9.50041C7.61739 9.50041 7.73051 9.45343 7.81699 9.36875L12.6562 4.63688V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.402084edde2982bc6107806f4af2f82c.svg";
export { ForwardRef as ReactComponent };